import { ComponentsModule } from './../components/components.module';
import { OcorrencesModule } from './ocorrences/ocorrences.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './../app-routing.module';
import { MaterialModule } from './../material.module';
import { AuthModule } from './auth/auth.module';
import { UserModule } from './user/user.module';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ChartsModule } from 'ng2-charts';
import { NguiMapModule } from '@ngui/map';
import { AgmCoreModule } from '@agm/core';
import { NgModule } from '@angular/core';
import { BusinessComponent } from './business/business.component';
import { SupportModule } from './support/support.module';
import { ModalHistoryStatusComponent } from './ocorrences/modal-history-status/modal-history-status.component';
import { MatStepperModule } from '@angular/material/stepper';
@NgModule({
	exports: [],
	imports: [
		ReactiveFormsModule,
		AppRoutingModule,
		OcorrencesModule,
		ComponentsModule,
		MaterialModule,
		ChartsModule,
		MatStepperModule,
		CommonModule,
		RouterModule,
		FormsModule,

		AuthModule,
		UserModule,
		NguiMapModule.forRoot({
			apiUrl:
				'https://maps.google.com/maps/api/js?key=AIzaSyDVO2M65l7mXKNWwbAoW64HJk2c7o1kQl8&libraries=visualization',
		}),
		AgmCoreModule.forRoot({
			apiKey: 'AIzaSyDVO2M65l7mXKNWwbAoW64HJk2c7o1kQl8',
		}),
	],
	declarations: [BusinessComponent],
})
export class PagesModule {}
